import {isAragUser, isSolicitorUser} from "../functions";
import editingSettings from "../../reducers/editingSettings";
import {APPLICATION_FORM_FIELDS} from "../variables";

export const checkIfUserRolesCanEditAnswerBasedOnEditingOption = (userRoles, editingSettingOption) => {
    if(editingSettingOption.machineName === "NotEditable"){
        return false;
    }

    if(
        editingSettingOption.machineName === "Solicitor"
        && isSolicitorUser(userRoles)
    ){
        return  true
    }

    if(
        editingSettingOption.machineName === "Arag"
        && isAragUser(userRoles)
    ){
        return  true
    }

    if(
        editingSettingOption.machineName === "SolicitorWithApproval"
        && isSolicitorUser(userRoles)
    ){
        return  true
    }

    if(
        editingSettingOption.machineName === "SolicitorOrArag"
        && (
            isSolicitorUser(userRoles)
            || isAragUser(userRoles)
        )
    ){
        return  true
    }

    if(
        editingSettingOption.machineName === "SolicitorWithAragApprovalOrArag"
        && (
            isSolicitorUser(userRoles)
            || isAragUser(userRoles)
        )
    ){
        return  true
    }

    return false;
};

export const getEditingSettingFromQuestionOrField = (question, fieldName, tableName, editingSettings) => {
    return editingSettings.find(setting => {
        if(
            fieldName
            && setting.columnName
            && setting.columnName.toLowerCase() === fieldName.toLowerCase()
        ){
            return true;
        }

        if(
            !fieldName
            && setting.questionId
            && setting.questionId.toString() === question.id.toString()
        ){
            return true;
        }

        if(
            tableName
            && question
            && setting.tableName
            && setting.tableName.toLowerCase() === tableName.toLowerCase()
            && (question.machineName === "OpponentName" || question.machineName === "EstimateForMedicalExpertFees")
        ) {
            return true
        }

        return false;
    });

};

export const checkIfQuestionAnswerUpdateRequiresARAGApproval = (editingSetting, approvalOptions, userRoles = []) => {
    approvalOptions = approvalOptions || [];
    editingSetting = editingSetting || {};
    const foundOptions = approvalOptions.find(option => option.id === editingSetting.applicationAnswerApprovalOptionId);

    if(
        foundOptions
        && foundOptions.machineName === "SolicitorWithApproval"
    ){
        return  true;
    }

    if(
        foundOptions
        && foundOptions.machineName === "SolicitorWithAragApprovalOrArag"
    ){
        // Solicitor edits require ARAG approval; ARAG users edit directly.
        return !isAragUser(userRoles);
    }

    return false;
};

// RETURNS THE APPROVAL SETTING THAT MATCHES THE GIVEN ID
export const getApprovalSettingById = (approvalSettings, approvalSettingId) => {
    return approvalSettings.find(setting => setting.id.toString() === approvalSettingId.toString())
};

// MAPS AN APPROVAL SETTING TO A QUESTION. A QUESTION CAN BE AN APPLICATION QUESTION, APP FIELD, OPPONENT QUESTION
// OR A MEDICAL EXPERT FEES TABLE
// THE QUESTIONS PASSED AS AN ARGUMENT MUST BE FLATTENED
export const mapApprovalSettingToQuestion = (approvalSetting, questions) => {
    if(!approvalSetting) {
        return null
    }

    // if approval setting is of type question
    if(approvalSetting.questionId){
        return questions.find(q => q.id.toString() === approvalSetting.questionId.toString())
    }

    //if approval setting is of type opponent
    if(approvalSetting.tableName === "ApplicationOpponent") {
        const question = questions.find(q => q.machineName === "OpponentName");
        return question;
    }

    //if approval setting is of type medical expert fees
    if(approvalSetting.tableName === "ApplicationMedicalExpertFees") {
        const question = questions.find(q => q.machineName === "EstimateForMedicalExpertFees");
        return question;
    }

    // if approval setting is of type application field

    if(
        approvalSetting.tableName === "Application"
        && approvalSetting.columnName === "SolicitorReference") {
        return APPLICATION_FORM_FIELDS.SOLICITOR_REFERENCE.fakeQuestion;
    }

    if(
        approvalSetting.tableName === "Application"
        && approvalSetting.columnName === "ClientName") {
        return APPLICATION_FORM_FIELDS.CLIENT_NAME.fakeQuestion;
    }

    if(
        approvalSetting.tableName === "Application"
        && approvalSetting.columnName === "Address") {
        return APPLICATION_FORM_FIELDS.ADDRESS.fakeQuestion;
    }

    if(
        approvalSetting.tableName === "Application"
        && approvalSetting.columnName === "PostCode") {
        return APPLICATION_FORM_FIELDS.POST_CODE.fakeQuestion;
    }

    if(
        approvalSetting.tableName === "Application"
        && approvalSetting.columnName === "DateOfBirth") {
        return APPLICATION_FORM_FIELDS.DATE_OF_BIRTH.fakeQuestion;
    }

    if(
        approvalSetting.tableName === "Application"
        && approvalSetting.columnName === "WorkSourceId") {
        return APPLICATION_FORM_FIELDS.WORK_SOURCE.fakeQuestion;
    }


};